import React from 'react';
import 'react-circular-progressbar/dist/styles.css';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import '../QuizAssessment.scss';
import CountUp from 'react-countup';
import { ProgressProvider, getColor } from '../helpers';

const TabItem = ({
  correct,
  completed,
  percentage,
  subcategoryName,
  totalCount,
  isActive = false,
}) => {
  const { trailColor, pathColor } = getColor(percentage);

  const totalProgress = (completed / totalCount) * 100;

  return (
    <div
      style={{
        border: '2px solid #ccc',
        padding: '10px 25px',
        borderRadius: 8,
        borderColor: isActive ? 'rgb(242,180,62)' : '#ccc',
      }}
      className="QuizAssessment__slider-wrapper"
    >
      <div className="QuizAssessment__slider-title-tabs">
        {subcategoryName.replaceAll('-', ' ')}
      </div>
      <div
        style={{ position: 'relative' }}
        className="QuizAssessment__slider-box"
      >
        <div style={{ position: 'absolute', padding: 16 }}>
          <ProgressProvider valueStart={0} valueEnd={percentage}>
            {(value) => (
              <CircularProgressbarWithChildren
                strokeWidth={14}
                value={value}
                styles={buildStyles({
                  pathTransitionDuration: 2,
                  pathColor,
                  trailColor,
                })}
              >
                <div
                  style={{ marginTop: -14, color: pathColor }}
                  className="QuizAssessment__circular-progress-bar-tabs"
                >
                  <CountUp duration={2} start={0} end={value} />%
                </div>
              </CircularProgressbarWithChildren>
            )}
          </ProgressProvider>
        </div>
        <ProgressProvider valueStart={0} valueEnd={totalProgress}>
          {(value) => (
            <CircularProgressbarWithChildren
              strokeWidth={12}
              value={value}
              styles={buildStyles({
                pathTransitionDuration: 2,
                pathColor: 'rgb(32,100,251)',
                trailColor: 'rgba(32,100,251,0.2)',
              })}
            >
              <div
                style={{ marginTop: 14, color: 'rgb(32,100,251)' }}
                className="QuizAssessment__circular-progress-bar-tabs"
              >
                <CountUp duration={2} start={0} end={value} />%
              </div>
            </CircularProgressbarWithChildren>
          )}
        </ProgressProvider>

        <div className="QuizAssessment__box-stats">
          <div
            style={{ color: pathColor }}
            className="QuizAssessment__box-stats-actions"
          >
            ACCURACY:
          </div>
          <div
            style={{ color: pathColor }}
            className="QuizAssessment__box-stats-actions"
          >
            <CountUp duration={2} start={0} end={correct} /> /
            <div>{completed}</div>
          </div>
        </div>

        <div className="QuizAssessment__box-stats">
          <div
            style={{ color: 'rgb(32,100,251)' }}
            className="QuizAssessment__box-stats-actions"
          >
            PROGRESS:
          </div>
          <div
            style={{ color: 'rgb(32,100,251)' }}
            className="QuizAssessment__box-stats-actions"
          >
            <CountUp duration={2} start={0} end={completed} /> /
            <div>{totalCount}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TabItem;
